import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: SENTRY_DSN,
  release: COMMIT_HASH,
  denyUrls: [
    /extensions\//i,
    /extension:/i,
    /^chrome:\/\//i,
    /amazon-adsystem/i,
    /load-google-maps-api/i,
    /serviceworker/i,
    /prebid\/dynamic/i,
    /get\.s-onetag\.com/i,
    /googleads\.g\.doubleclick\.net/i,
    /instagram\.com/i,
    /s\.yimg\.jp/i,
    /twitter\.com/i,
    /fbevents\.js/i,
    /ftutils\.js/i,
    /grumi-ip\.js/i,
  ],
  ignoreErrors: [
    /can't execute code from a freed script/i,
    /can't find variable: (yahoo|gmo)/i,
    /securityerror: blocked a frame with origin/i,
    /serviceworker/i,
    "Function expected",
  ],
  autoSessionTracking: false,
  enableTracing: false,
});
